import Vue from 'vue'
import { formatNumber } from '@/lib/utils'
import { formatDate } from '@/lib/date'

Vue.filter('formatNumber', (value, decimals = 2) => {
    return value ? formatNumber(value, decimals) : 'N/A'
})

Vue.filter('formatDate', (value, format = 'DD/MM/YYYY') => {
    return formatDate(value, format)
})
